import React from 'react';


import './header.css';
import logo from './BulbyTechLogo.png'

import { useState, useEffect  } from 'react';

//eslint-disable-next-line
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//eslint-disable-next-line
import { faBars } from '@fortawesome/free-solid-svg-icons'
//eslint-disable-next-line
import HeaderLink from './link/link'

import Nav from './nav/nav'

function Header(props) {

    const [anim, setAnim] = useState(false);
    const [secondary, setSecondary] = useState(false);

    function toggleAnim(){
        console.log("toggleing animation")
        setTimeout( () =>
            setAnim(!anim), 
        750)
        setTimeout( () =>
            setSecondary(!secondary), 
        1250)
    }

    useEffect(() => 
    //eslint-disable-next-line
        toggleAnim(), []
    )

    function scrollToComponent(index) {
        console.log("scrolling to compontent -- " + index)
        props.refArr[index].current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
      <div className="header--container">
        <div className="logo--container">
            <img src={logo} onClick={() => scrollToComponent(0)} className="header--logo" alt="main--logo"/>
        </div>
        
        <Nav >
            <button className="nav--link " onClick={() => scrollToComponent(1) } >Services</button>
            <button className="nav--link " onClick={() => scrollToComponent(2)}>Portfolio</button>
            <button className="nav--link " onClick={() => scrollToComponent(3)} >Testimonials</button>
            <button className="nav--link " onClick={() => scrollToComponent(4)} >Contact</button>
        </Nav>
        
      </div>
    );
  }
  
  export default Header;
  